import { extendVariants } from "@heroui/react";
import { Button } from "./override/button.c";

export const CtaButton = extendVariants(Button, {
  variants: {
    size: {},
  },
  defaultVariants: {
    color: "primary",
  },
  compoundVariants: [
    {
      class: "text-white",
    },
  ],
});
